import {
    FieldTypes, BasketArticleDto, ArticleExtendedProperty, IBasketArticleDto,
    CategoryDto
} from '@shared/service-proxies/service-proxies';

import * as _ from 'lodash-es';

export interface IColumnDefinition {
    type: number;
    field: string;
    header: string;

    colWidth?: string;
    height?: number;
}

export class ColumnDefinition implements IColumnDefinition  {
    public type: number;
    public field: string;
    public header: string;

    public height?: number;
    public colWidth?: string;
    public sorting: boolean;
}


export interface IBasketArticleExtendedDto extends IBasketArticleDto {
    backorderQuantity: number;
}
export class BasketArticleExtendedDto
    extends BasketArticleDto
    implements IBasketArticleExtendedDto {

    backorderQuantity: number;

    constructor(data?: IBasketArticleDto) {
        super(data);

        this.backorderQuantity = 0;
    }

}


//#region Backorder
export class BackOrder {

    private _isBackorderAvailable: boolean;
    set isBackorderAvailable(value: boolean) {
        this._isBackorderAvailable = value;
    }
    get isBackorderAvailable(): boolean {
        return this._isBackorderAvailable;
    }

    check(basket: BasketArticleExtendedDto[]) {
        this.isBackorderAvailable = this._backOrderDetector(basket);
    }

    private _backOrderDetector(basket: BasketArticleExtendedDto[]): boolean {
        if (basket.length == 0) return false;

        let isAvailable = false;

        for (let i = 0; i < basket.length; i++) {
            const item = basket[i];

            if (item.backorderQuantity > 0) {
                isAvailable = true;
            }

            this._changeItem(item);
        }

        return isAvailable;
    }


    private _backorderBasket: BasketArticleExtendedDto[];
    set backorderBasket(item: BasketArticleExtendedDto[]) {
        if (item) {
            this._backorderBasket = [...item];
        }
    }
    get backorderBasket(): BasketArticleExtendedDto[] {
        if (!this._backorderBasket) {
            this._backorderBasket = [];
        }

        return this._backorderBasket;
    }

    private _changeItem(article: BasketArticleExtendedDto) {
        let item = _.find(this.backorderBasket,
            (item) => {
                return item.id === article.id;
            });

        if (item) {
            if (item.backorderQuantity <= 0) {
                this.remove(item.id);
                return;
            }
        }

        if (!item && article.backorderQuantity == 0) {
            return;
        }

        if (item && article.backorderQuantity == 0) {
            this.remove(item.id);
            article.quantity += item.quantity;
            return;
        }

        if (item) {
            item.quantity = article.backorderQuantity;
        } else {
            let backOrderItem = _.cloneDeep(article);
            backOrderItem.quantity =  article.backorderQuantity;
            this.backorderBasket = [...this.backorderBasket, backOrderItem];
        }
    }

    remove(id: string) {
        if (!id) return;

        let basket = this.backorderBasket;

        _.remove(basket,
            (item) => {
                return item.id === id;
            });

        this.backorderBasket = basket;
    }

}

//#endregion Backorder



//Package model
export interface IAxillaPackage {
    //all information about pallet for this package
    pallets: AxillaPallet[]
}

export class AxillaPackage implements IAxillaPackage  {
    private _pallets: AxillaPallet[];

    get pallets(): AxillaPallet[] {
        return this._pallets;
    }

    //Get pallets Count
    get palletCount(): number {
        return this._pallets.length;
    }


    constructor() {
        this._initPallets();
    }

    private _initPallets() {
        this._pallets = [];
    }


    get getLastPalletIndex(): number {
        return this.palletCount - 1;
    }

    addPallet(pallet: AxillaPallet) {
        if (pallet.articles.length >= 0) {
            this._pallets.push(pallet);
        }
    }

    clear() {
        this._initPallets();
    }

    //TODO: implement logic of add article to pallet
    removeArticle(id: string) {
        if (!id) return;

        let index = this._getPalletIndexByArticle(id);
        let currentPallet: AxillaPallet = null;
        if (index == -1) {
            currentPallet = this.pallets[this.palletCount - 1];
        } else {
            currentPallet = this.pallets[index];
        }

        _.remove(currentPallet.articles,
            (item) => {
                return item.id === id;
            });

        currentPallet.usedSpace = (100 * --currentPallet.parcelCount) / currentPallet.parcelMAXCount;
        currentPallet.freeSpace = 100 - currentPallet.usedSpace;

        if (currentPallet.articles.length == 0) {
            _.remove(this.pallets, currentPallet);
        }
    }

    //rulebook 1: 1 Article 1 palet
    addArticle(article: BasketArticleDto) {
        //TODO: implement logic of add article to pallet
        if (article) {
            if (this.palletCount == 0) {
                this._createNewPallet(article);
            } else {
                let currentPallet: AxillaPallet = null;
                let index = this._getPalletIndexByArticle(article.id);
                if (index == -1) {
                    currentPallet = this.pallets[this.palletCount-1];
                } else {
                    currentPallet = this.pallets[index];

                    const contains = _.find(currentPallet.articles,
                        (item) => {
                            return item.id === article.id;
                        });

                    if (contains && contains.quantity != article.quantity) {
                        _.remove(currentPallet.articles,
                            (item) => {
                                return item.id === article.id;
                            });
                    } else {
                        return;
                    }
                }

                if (currentPallet && currentPallet.parcelCount < currentPallet.parcelMAXCount) {

                    currentPallet.usedSpace = (100 * ++currentPallet.parcelCount) / currentPallet.parcelMAXCount;
                    currentPallet.freeSpace = 100 - currentPallet.usedSpace;

                    currentPallet.articles.push(article);
                } else {
                    currentPallet.showDimension = false;

                    this._createNewPallet(article);
                }
            }
        }
    }

    private _getPalletIndexByArticle(id: string): number {

        let index = -1;

        for (var i = 0; i < this.pallets.length; i++) {
            let pallet = this.pallets[i];

            let item = _.find(pallet.articles,
                (article) => {
                    return article.id === id;
                });

            if (item) {
                index = i;
                return index;
            }
        }

        return index;
    }

    private _createNewPallet(article: BasketArticleDto) {
        const parcelMAXCount = _.random(1, 5);

        const articles: BasketArticleDto[] = [];
        articles.push(article);

        const usedSpace = (100 * 1) / parcelMAXCount;
        const freeSpace = 100 - usedSpace;

        //TODO: implement pallet edditiong functionality
        const pallet: AxillaPallet = {
            dimension: new AxillaPalletDimension(),
            articles: articles,
            freeSpace: freeSpace,
            usedSpace: usedSpace,
            parcelCount: 1,
            parcelMAXCount: parcelMAXCount,
            showDimension: true
        }

        this.addPallet(pallet)
    }

}



//Pallet information 
export class AxillaPallet {
    //indicates how much space left free to calculate how much we can put inside
    freeSpace: number = 100;
    //indicates how much space userd
    usedSpace: number = 0;
    //show which articles belong to this pallet 
    articles: BasketArticleDto[] = [];
    //show pallet dimension 
    dimension: AxillaPalletDimension;

    showDimension: boolean = false;

    parcelCount: number;

    parcelMAXCount: number;
}

//Pallet dimension information 
export class AxillaPalletDimension {
    //indicates total weight of pallet
    weight: number;
    //indicates width of pallet
    width: number;
    //indicates depth of pallet
    depth: number;
    //indicates height of pallet
    height: number;

    constructor() {
        this.weight = _.random(20, 270);
        this.width = _.random(1200, 1200);
        this.depth = _.random(800, 800);
        this.height = _.random(1800, 1800);
    }
}
